import { create } from 'zustand';
import { DailyLog, WeeklySummary } from '@/types/report';

interface ReportState {
  dailyLogs: DailyLog[];
  weeklySummaries: WeeklySummary[];
  setDailyLogs: (logs: DailyLog[]) => void;
  setWeeklySummaries: (summaries: WeeklySummary[]) => void;
  addDailyLog: (log: DailyLog) => void;
  updateDailyLog: (id: number, log: Partial<DailyLog>) => void;
  removeDailyLog: (id: number) => void;
  addWeeklySummary: (summary: WeeklySummary) => void;
  updateWeeklySummary: (id: number, summary: Partial<WeeklySummary>) => void;
  removeWeeklySummary: (id: number) => void;
}

export const useReportStore = create<ReportState>((set) => ({
  dailyLogs: [],
  weeklySummaries: [],
  setDailyLogs: (logs) => set({ dailyLogs: logs }),
  setWeeklySummaries: (summaries) => set({ weeklySummaries: summaries }),
  addDailyLog: (log) =>
    set((state) => ({ dailyLogs: [...state.dailyLogs, log] })),
  updateDailyLog: (id, updatedLog) =>
    set((state) => ({
      dailyLogs: state.dailyLogs.map((log) =>
        log.id === id ? { ...log, ...updatedLog } : log
      ),
    })),
  removeDailyLog: (id) =>
    set((state) => ({
      dailyLogs: state.dailyLogs.filter((log) => log.id !== id),
    })),
  addWeeklySummary: (summary) =>
    set((state) => ({ weeklySummaries: [...state.weeklySummaries, summary] })),
  updateWeeklySummary: (id, updatedSummary) =>
    set((state) => ({
      weeklySummaries: state.weeklySummaries.map((summary) =>
        summary.id === id ? { ...summary, ...updatedSummary } : summary
      ),
    })),
  removeWeeklySummary: (id) =>
    set((state) => ({
      weeklySummaries: state.weeklySummaries.filter((summary) => summary.id !== id),
    })),
}));
